import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "bulkActions", "selectedCount", "approveForm", "rejectForm"]

  connect() {
    this.updateBulkActions()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateBulkActions()
  }

  toggleCheckbox() {
    this.updateBulkActions()

    // Update "select all" checkbox state
    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    const someChecked = this.checkboxTargets.some(cb => cb.checked)

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = allChecked
      this.selectAllTarget.indeterminate = someChecked && !allChecked
    }
  }

  updateBulkActions() {
    const selectedCount = this.selectedCheckboxes.length

    if (this.hasBulkActionsTarget) {
      if (selectedCount > 0) {
        this.bulkActionsTarget.classList.remove("hidden")
      } else {
        this.bulkActionsTarget.classList.add("hidden")
      }
    }

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = selectedCount
    }
  }

  bulkApprove(event) {
    event.preventDefault()

    const selectedIds = this.selectedCheckboxes.map(cb => cb.value)
    if (selectedIds.length === 0) {
      alert("Selecione pelo menos uma venda para aprovar.")
      return
    }

    const confirmed = confirm(`Tem certeza que deseja aprovar ${selectedIds.length} venda(s)?`)
    if (!confirmed) return

    this.submitBulkAction(this.approveFormTarget, selectedIds)
  }

  bulkReject(event) {
    event.preventDefault()

    const selectedIds = this.selectedCheckboxes.map(cb => cb.value)
    if (selectedIds.length === 0) {
      alert("Selecione pelo menos uma venda para rejeitar.")
      return
    }

    const confirmed = confirm(`Tem certeza que deseja rejeitar ${selectedIds.length} venda(s)? Esta ação não pode ser desfeita.`)
    if (!confirmed) return

    this.submitBulkAction(this.rejectFormTarget, selectedIds)
  }

  submitBulkAction(form, selectedIds) {
    // Remove existing hidden inputs
    form.querySelectorAll('input[name="direct_sale_ids[]"]').forEach(input => input.remove())
    form.querySelectorAll('[data-quote-revision-input]').forEach(input => input.remove())
    this.selectedCheckboxes.forEach(checkbox => {
      if (!checkbox.dataset.quoteRevision) return
      const revision = document.createElement('input')
      revision.type = 'hidden'
      revision.name = `quote_revisions[${checkbox.value}]`
      revision.value = checkbox.dataset.quoteRevision
      revision.dataset.quoteRevisionInput = 'true'
      form.appendChild(revision)
    })

    // Add selected IDs as hidden inputs
    selectedIds.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'direct_sale_ids[]'
      input.value = id
      form.appendChild(input)
    })

    form.submit()
  }

  get selectedCheckboxes() {
    return this.checkboxTargets.filter(cb => cb.checked)
  }
}
